/* eslint-disable react/no-array-index-key */
import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';

import {
  clearFiles,
  fetchFiles,
  setFilesParams,
} from '../../actions/Files';

import FilesGridItem from '../Files/GridItem';
import DashboardWidgetPlaceholderFile from './WidgetPlaceholderFile';
import DashboardWidgetSkeletonFile from './WidgetSkeletonFile';
import DashboardWidgetUploadFile from './WidgetUploadFile';

import { getDashboardComponentSettings } from '../../helpers/Dashboard';

const DashboardWidgetRecentFiles = ({ getFiles, files, loading }) => {
  const intl = useIntl();

  const [rowHeight, setRowHeight] = useState(null);

  const containerRef = useRef(null);

  const componentSetting = getDashboardComponentSettings('recent-files');
  const rowCount = componentSetting ? componentSetting.h : 1;

  useEffect(() => {
    getFiles();
  }, [getFiles]);

  const handleChangeRowHeight = useCallback(() => {
    if (containerRef.current) {
      const computedStyle = window.getComputedStyle(containerRef.current);
      const gap = parseFloat(computedStyle.getPropertyValue('row-gap'));

      let firstChildHeight = 0;
      const firstChild = containerRef.current.firstElementChild;
      if (firstChild) {
        firstChildHeight = parseFloat(window.getComputedStyle(firstChild).getPropertyValue('height'));
      }

      setRowHeight((firstChildHeight * rowCount) + (gap * rowCount) - 1);
    }
  }, [rowCount]);

  useEffect(() => {
    handleChangeRowHeight();
  }, [handleChangeRowHeight]);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(handleChangeRowHeight);
    const dashboard = document.querySelector('#dashboard-component-recent-files');

    resizeObserver.observe(dashboard);

    return () => {
      resizeObserver.unobserve(dashboard);
    };
  }, [handleChangeRowHeight]);

  return (
    <div className="dashboard-section">
      <div className="dashboard-section-title">
        <div>
          <h3>{intl.formatMessage({ defaultMessage: 'Recent files' })}</h3>
          <Link to="/files">
            <span>{intl.formatMessage({ defaultMessage: 'See all' })}</span>
          </Link>
        </div>
      </div>
      <div className="dashboard-section-content">
        <div className="dashboard-section-recent-files-wrapper files-grid" ref={containerRef} style={{ height: rowHeight || 'unset' }}>
          <DashboardWidgetUploadFile />
          {!loading && files.map(f => (
            <FilesGridItem
              id={f.uuid}
              index={f.uuid}
              key={f.uuid}
              file={f}
              moveFile={null}
              saveFiles={() => {}}
              handleMoveSelectedItems={() => {}}
              isMoved={false}
              isSelected={false}
              onFileSelect={() => {}}
              allowCheck={false}
            />
          ))}
          {loading ?
            [...Array(18)].map((_, i) => <DashboardWidgetSkeletonFile key={i} />) :
            files.length < 18 && [...Array(18 - files.length)].map((_, i) => <DashboardWidgetPlaceholderFile key={`dp-${i}`} />)}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  files: state.Files.files,
  loading: state.Files.loading,
});

const mapDispatchToProps = (dispatch) => ({
  getFiles: () => {
    dispatch(clearFiles());
    dispatch(setFilesParams({
      page: 0,
      noFilters: true,
    }));
    dispatch(fetchFiles());
  },
});

DashboardWidgetRecentFiles.propTypes = {
  getFiles: PropTypes.func.isRequired,
  files: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardWidgetRecentFiles);
